<template>
  <div class="course">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Dados do Curso</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Título
                      <span class="required-field">*</span>
                    </label>
                    <input v-model="course.title" type="text" class="form-control" />
                  </div>
                </div>
                <div
                  class
                  v-bind:class="{'col-lg-9':course.file_path, 'col-lg-12': !course.file_path}"
                >
                  <div class="form-group">
                    <label for>{{course.file_path ? 'Alterar Apostila' : 'Apostila'}}</label>
                    <b-form-file
                      placeholder="Escolha um arquivo"
                      drop-placeholder="Arraste o arquivo aqui..."
                      browse-text="Procurar"
                      accept="application/pdf"
                      v-on:change="uploadFile"
                    ></b-form-file>
                  </div>
                </div>
                <div class="col-lg-3" v-if="course.file_path">
                  <div
                    class="w-100 h-100 d-flex-align-items-center justify-content-end"
                    style="padding-top: 32px;"
                  >
                    <a :href="course.file_url" target="_blank" rel="noopener noreferrer">
                      <button class="btn btn-primary float-right">Ver apostila atual</button>
                    </a>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>
                      Revistas
                      <span class="required-field">*</span>
                    </label>
                    <multiselect
                      v-model="magazines"
                      :multiple="true"
                      :options="createParams.magazines"
                      selectLabel="Selecione essa revista"
                      deselectLabel="Remova essa revista"
                      selectedLabel="Selecionada"
                      track-by="id"
                      label="name"
                      placeholder="Selecione as revistas"
                    ></multiselect>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-primary float-right"
                    style="margin-left: 12px"
                    v-on:click="save()"
                  >Salvar</button>
                  <button
                    class="btn btn-secondary float-right"
                    v-if="formType == 'edit'"
                    v-on:click="destroy()"
                  >Excluir</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Multiselect from "vue-multiselect";
import course_validate from "@/imports/validator/models/course";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "course",
  props: {
    id: Number
  },
  components: {
    Multiselect
  },
  data() {
    return {
      course: {},
      tempFile: "",
      createParams: {
        magazines: []
      },
      magazines: [],
      formType: "create",
      items: [
        {
          text: "Cursos",
          route: "admin.courses"
        },
        {
          text: "Novo Curso",
          active: true
        }
      ]
    };
  },
  mounted() {
    bus.$emit("changeLoading", true);
    this.getCreateParams();
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/courses/${id}`)
        .then(response => {
          this.course = response.data;
          this.magazines = this.course.magazines;
          this.items[1].text = this.course.title;
          bus.$emit("changeLoading", false);
        });
    },
    uploadFile: function(e) {
      const file = e.target.files[0];
      if (!file.type.includes("/pdf")) {
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.tempFile = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    getCreateParams: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/courses/create`)
        .then(data => {
          this.createParams = data.data;
          if (this.id) {
            this.formType = "edit";
            this.getDataObject(this.id);
          } else {
            bus.$emit("changeLoading", false);
          }
        });
    },
    save: function() {
      if (this.tempFile != "") {
        this.course.file = this.tempFile;
      }
      let magazines_ids = [];
      this.magazines.forEach(el => magazines_ids.push(el.id));
      this.course.magazines = magazines_ids;

      let errors = validator.validate(this.course, course_validate.model);

      if (errors.length == 0) {
        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/courses`,
                this.course
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/courses/${this.course.id}`,
                this.course
              );
        bus.$emit("changeLoading", true);
        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Curso cadastrado"
                  : "Curso alterado com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.courses" });
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        bus.$emit("changeLoading", false);
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    },
    destroy: function() {
      Swal.fire({
        title: "Você tem certeza que deseja excluir esse item?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.value) {
          let promise = axios.delete(
            `${process.env.VUE_APP_API_HOST}/api/courses/${this.course.id}`
          );

          promise.then(response => {
            Swal.fire({
              title: "Item excluído com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.courses" });
              }
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>